// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.acceptance.LeaseDisclaimerAcceptanceFromOuidWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid,
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_Path,
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid,
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_Path,
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid,
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetAttachedLeaseAcceptanceFromOuidResponseDto,
  GetDisclaimerAcceptanceFromOuidResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetAttachedLeaseAcceptanceForUserFromOuidParams {
  ouid: string;
}
interface GetDisclaimerAcceptanceForUserFromOuidParams {
  ouid: string;
}
interface SetAttachedLeaseAcceptanceForUserFromOuidParams {
  ouid: string;
}
interface SetDisclaimerAcceptanceForUserFromOuidParams {
  ouid: string;
}

export type LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_Options =
  UseQueryOptions<
    GetAttachedLeaseAcceptanceFromOuidResponseDto,
    unknown,
    GetAttachedLeaseAcceptanceFromOuidResponseDto,
    Array<string | GetAttachedLeaseAcceptanceForUserFromOuidParams>
  >;

const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_GetKey = (
  getParams: GetAttachedLeaseAcceptanceForUserFromOuidParams,
) => [LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_Path, getParams];

/**
 * get attached lease acceptance status for leasing user from ouid
 */
export const useLeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid = (
  getParams: GetAttachedLeaseAcceptanceForUserFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<
    LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey:
      LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_GetKey(getParams),
    queryFn: () =>
      LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid(getParams, httpClient),
  });
};
useLeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid.getKey =
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_GetKey;

export type LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_Options =
  UseQueryOptions<
    GetDisclaimerAcceptanceFromOuidResponseDto,
    unknown,
    GetDisclaimerAcceptanceFromOuidResponseDto,
    Array<string | GetDisclaimerAcceptanceForUserFromOuidParams>
  >;

const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_GetKey = (
  getParams: GetDisclaimerAcceptanceForUserFromOuidParams,
) => [LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_Path, getParams];

/**
 * get disclaimer acceptance status for leasing user from ouid
 */
export const useLeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid = (
  getParams: GetDisclaimerAcceptanceForUserFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<
    LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_GetKey(getParams),
    queryFn: () =>
      LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid(getParams, httpClient),
  });
};
useLeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid.getKey =
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_GetKey;

export interface LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Args {
  getParams: SetAttachedLeaseAcceptanceForUserFromOuidParams;
}

export type LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Options =
  UseMutationOptions<
    void,
    unknown,
    LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Args
  >;

/**
 * set attached lease acceptance for leasing user from ouid
 */
export const useLeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid = ({
  httpClient,
  ...options
}: Omit<
  LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Args) =>
      LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid(
        args.getParams,
        httpClient,
      ),
  });
};

export interface LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Args {
  getParams: SetDisclaimerAcceptanceForUserFromOuidParams;
}

export type LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Options =
  UseMutationOptions<
    void,
    unknown,
    LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Args
  >;

/**
 * set disclaimer acceptance for leasing user from ouid
 */
export const useLeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid = ({
  httpClient,
  ...options
}: Omit<LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Args) =>
      LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid(args.getParams, httpClient),
  });
};
